import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../../../core/store/auth.store";
import LoaderScreen from "../../../components/loaders/LoaderScreen";


const PublicRoute: FC = () => {
  const { isLoading, isAuthenticated } = useAuthStore();

  if (isLoading) return <LoaderScreen />;

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
export default PublicRoute;
